import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface CortexMarkProps {
    className?: string
    title?: string
}

interface LogoProps {
    className?: string
    markClassName?: string
}

/**
 * The Cortex mark: a solid ring with an offset opening, echoing the
 * oculus of the pavilion in the hero image and the letter C.
 */
export const CortexMark: FC<CortexMarkProps> = ({ className, title }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            className={cn('size-6 shrink-0', className)}
            fill='currentColor'
            role={title ? 'img' : undefined}
            aria-hidden={title ? undefined : true}
            aria-label={title}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16 1a15 15 0 1 0 0 30a15 15 0 1 0 0-30Z M19 4.5a8.5 8.5 0 1 0 0 17a8.5 8.5 0 1 0 0-17Z'
            />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, markClassName }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5 text-foreground', className)}>
            <CortexMark className={cn('size-[22px]', markClassName)} />

            <span className='font-heading text-[1.3rem] leading-none font-medium tracking-[-0.045em]'>
                Cortex
            </span>
        </span>
    )
}
